import { computed } from 'vue'
import store from '@/store'

export default function useDirection() {
  const directionsForDropdown = computed(() => store.getters['employee/directionsForDropdown'])
  
  const fetchDirectionsForDropdown = async () => {
    if (!directionsForDropdown.value.length) {
      await store.dispatch('employee/getDirectionForDropdown')
    }
  }

  return {
    directionsForDropdown,
    
    fetchDirectionsForDropdown
  }
}
